import { render, staticRenderFns, recyclableRender, components } from "./u-picker.vue?vue&type=template&id=d45639b2&scoped=true&"
var renderjs
import script from "./u-picker.vue?vue&type=script&lang=js&"
export * from "./u-picker.vue?vue&type=script&lang=js&"
import style0 from "./u-picker.vue?vue&type=style&index=0&id=d45639b2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../办公/HBuilderX.3.8.12.20230817/HBuilderX/plugins/uniapp-cli/node_modules/@dcloudio/vue-cli-plugin-uni/packages/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d45639b2",
  null,
  false,
  components,
  renderjs
)

component.options.__file = "node_modules/uview-ui/components/u-picker/u-picker.vue"
export default component.exports